import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRemUnit } from 'utils/styled'
import { Caption, Text } from 'components/Typography'
import { colors } from 'utils/colors'
import { Stack } from 'components/Stack'

export const PerkCardBox = styled(Stack)`
  position: relative;
  box-shadow: 0 5px 40px #d2dce1;
  width: ${pxToRemUnit(310)};
  padding: 2rem 0;
  @media ${BREAKPOINTS.MD.max} {
    padding: 1.5rem 0;
  }
`
export const PerkCardPaddingWrapper = styled(Stack)`
  padding-left: 2rem;
  padding-right: 0.25rem;
  @media ${BREAKPOINTS.MD.max} {
    padding-left: 1.5rem;
  }
`

export const SIconWrapper = styled.div`
  height: ${pxToRemUnit(39)};
`

export const StyledBadge = styled.div<{ type: 'free' | 'premium' }>`
  position: absolute;
  top: 1.875rem;
  right: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.875rem;
  background-color: ${(props) => (props.type === 'free' ? colors.blue[100] : colors.gray[50])};
  padding: 2px 0.75rem;
`

export const SCaption = styled(Caption)``

export const SText = styled(Text)`
  font-size: 1.063rem;
`

export const SLinkText = styled(Text)<{
  hide: boolean
}>`
  text-decoration: underline;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
  ${({ hide }) => hide && 'visibility: hidden;'}
`
